export enum InboundAttachmentException {
  TicketAlreadyCompletedException = 'TicketAlreadyCompletedException',
  TicketCancelledException = 'TicketCancelledException',
  WrongStageException = 'WrongStageException',
  NoneOrMultipleAttachmentsException = 'NoneOrMultipleAttachmentsException',
}
